module.exports = __webpack_public_path__ + "img/80162089.bc2c5842.png";